import React, { useState, useEffect } from 'react';
import { Popover, Slider, Switch, Space, Divider, Button, message } from 'antd';

export default function AlertConfig({ visible, onClose, children }) {
  const [volume, setVolume] = useState(80);
  const [eternityAlarm, setEternityAlarm] = useState(true);
  const [namelesssAlarm, setNamelesssAlarm] = useState(true);

  // Carregar do cache quando abrir
  useEffect(() => {
    const savedConfig = localStorage.getItem('alertConfig');
    if (savedConfig) {
      const parsedConfig = JSON.parse(savedConfig);
      setVolume(parsedConfig.volume ?? 50);
      setEternityAlarm(parsedConfig.eternityAlarm ?? true);
      setNamelesssAlarm(parsedConfig.namelesssAlarm ?? true);
    }
  }, []);

  const handleVolumeChange = (value) => {
    setVolume(value);
  };

  const handleSave = () => {
    const config = {
      volume,
      eternityAlarm,
      namelesssAlarm
    };
    localStorage.setItem('alertConfig', JSON.stringify(config));
    message.success('Configurações salvas com sucesso!');
    onClose(); // Fecha o popover depois de salvar
  };

  const popoverContent = (
    <Space direction="vertical" style={{ width: '260px' }}>

      <div className="guild-one" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 12px' }}>
        <span><b>Alarme Eternity:</b></span>
        <Switch
          size="small"
          checked={eternityAlarm}
          onChange={setEternityAlarm}
          checkedChildren="On"
          unCheckedChildren="Off"
        />
      </div>

      <div className="guild-two" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, padding: '4px 12px' }}>
        <span><b>Alarme Namelesss:</b></span>
        <Switch
          size="small"
          checked={namelesssAlarm}
          onChange={setNamelesssAlarm}
          checkedChildren="On"
          unCheckedChildren="Off"
        />
      </div>

      <Divider style={{ margin: '12px 0' }} />

      <div>
        <b>Volume do Alarme:</b>
        <Slider
          min={0}
          max={100}
          value={volume}
          onChange={handleVolumeChange}
          size="small"
        />
      </div>

      <Button
        type="primary"
        block
        style={{ marginTop: 12 }}
        onClick={handleSave}
      >
        Save
      </Button>
    </Space>
  );

  return (
    <Popover
      content={popoverContent}
      title={null}
      trigger="click"
      open={visible}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      placement="bottom"
    >
      <div style={{ display: 'inline-block' }}>
        {children}
      </div>
    </Popover>
  );
}